export interface LEGAL_ISSUE {
    readonly value: string;
    readonly label: string;
    readonly isFixed?: boolean;
    readonly isDisabled?: boolean;
  }
  export const LEGAL_ISSUES: readonly LEGAL_ISSUE[]  = [
    { value: 'Tenancy other', label: 'Tenancy/Housing' },
    { value: 'Criminal other', label: 'Criminal Charges' },
    { value: 'Victims Compensation', label: 'Victim Support' },
    { value: 'Wills/probate other', label: 'Wills and Trusts' },
    { value: 'Employment other', label: 'Employment' },
    { value: 'Govt/admin complaints or issues relating to government other', label: 'Complaints about Government Authorities (eg police)' },
    { value: 'Govt/admin issues relating to fines', label: 'Fines' },
    { value: 'Credit & Debt', label: 'Debt' },
    { value: 'Family Law', label: 'Family Violence' },
    { value: 'Govt pensions benefits allowances other', label: 'Centrelink' },
    { value: 'Discrimination other', label: 'Discrimination or Harassment' },
    { value: 'Problem Type Other', label: 'Other' }
  ]
  